import { attributionStringToObject } from "../../actions/Tracking/utils";
import { VIDEO_CANONICAL_URL_BASE } from "../../constants/videos";

const subSectionsFromTracking = (tracking) => {
    if (!tracking) return {};
    return Object.entries(tracking).reduce((accum, [key, value]) => {
        const _key = key.toLowerCase();
        if (_key.startsWith("sub") && value) accum[_key] = value;
        return accum;
    }, {});
};

// VDP Analytics from ContentItem
export const getVideoDetailPageAnalytics = (contentItem) => {
    if (!contentItem || !contentItem.sourceId) return {};

    const contentType = `${contentItem.type}clip`;
    const contentArea =
        contentItem.media?.contentArea?.toLowerCase() ??
        contentItem.section?.tracking?.contentArea;

    const showName = contentItem.showData?.name ?? contentItem.showName;
    const department = attributionStringToObject(
        contentItem.section?.attributionLevels
    );
    const sponsor = {
        ...(contentItem.media?.brandedSponsorName
            ? { name: contentItem.media.brandedSponsorName }
            : {}),
    };
    const subsections = subSectionsFromTracking(contentItem.section?.tracking);

    const analyticData = {
        media: {
            audiovideo: contentItem.type,
            duration: contentItem.media?.duration,
            id: contentItem.sourceId,
            liveondemand: contentItem.media?.streamType,
            ...(contentItem.media?.sport
                ? { sport: contentItem.media.sport }
                : {}),
            ...(showName ? { show: showName } : {}),
        },
        publishedTime: parseInt(contentItem.publishedAt),
        contentid: contentItem.sourceId,

        keywords: {
            tags: contentItem.tags,
            concepts: contentItem.concepts,
        },
        type: contentType,
        title: contentItem.title,
        contenttype: contentType,
        pillar: "feed",
        preventDefault: true,
        spa: true,
        url: `${VIDEO_CANONICAL_URL_BASE}${contentItem.type}/${contentItem.sourceId}`,
        ...(contentArea ? { contentarea: contentArea } : {}),
        ...(Object.keys(sponsor).length ? { sponsor: sponsor } : {}),
        ...(Object.keys(department).length ? { department: department } : {}),
        ...(Object.keys(subsections).length ? subsections : {}),
    };

    return analyticData;
};
